import { useLightMode } from '@/hooks/useLightMode'
import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'
import { HiOutlineTrash } from 'react-icons/hi'

import { EditIcon, TableMenuButton, TableMenuButtonItem } from '@hivewatch/dark'

interface SOPsMenuButtonIProps {
  onEditClick: () => void
  onDeleteClick: () => void
}

export const SOPsMenuButton = ({
  onEditClick,
  onDeleteClick,
}: SOPsMenuButtonIProps) => {
  const { t } = useTranslation()
  const { shouldEnableUpdateSOP } = usePermissions()
  const colorScheme = useLightMode()
  const dangerColor =
    colorScheme === 'light' ? 'light.interactive.danger' : 'interactive.danger'

  const items: TableMenuButtonItem[] = [
    ...(shouldEnableUpdateSOP
      ? [
          {
            label: t('common:edit'),
            icon: <EditIcon size={16} />,
            onClick: onEditClick,
          },
        ]
      : []),
    ...(shouldEnableUpdateSOP
      ? [
          {
            label: t('common:delete'),
            icon: <HiOutlineTrash size={16} />,
            onClick: onDeleteClick,
            color: dangerColor,
          },
        ]
      : []),
  ]

  return <TableMenuButton colorScheme={colorScheme} items={items} />
}
